import type { FeedbackPost } from './types';

export type CreatorFeedbackSidebarStats = {
  yourPosts: number;
  needsReplies: number;
  helpedOnThreads: number;
};

/**
 * Derive sidebar stats from the already-subscribed feedback feed (recent posts only).
 * helpedOnThreads: posts you participated in (commented) but did not author, within this list.
 */
export function deriveCreatorFeedbackSidebarStats(
  posts: FeedbackPost[],
  userId: string | null | undefined
): CreatorFeedbackSidebarStats {
  if (!userId || !Array.isArray(posts) || posts.length === 0) {
    return { yourPosts: 0, needsReplies: 0, helpedOnThreads: 0 };
  }
  let yourPosts = 0;
  let needsReplies = 0;
  let helpedOnThreads = 0;
  for (const p of posts) {
    if (p.authorId !== userId) {
      const ids = Array.isArray(p.participantUserIds) ? p.participantUserIds : [];
      if (ids.includes(userId)) helpedOnThreads += 1;
      continue;
    }
    yourPosts += 1;
    if (p.status === 'open' && p.commentCount === 0) needsReplies += 1;
  }
  return { yourPosts, needsReplies, helpedOnThreads };
}
